import { Box, Checkbox, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import Table from 'src/components/UI/CustomUI/organisms/Table'
import {
    AlignType, HeaderType
} from 'src/components/UI/CustomUI/organisms/Table/types'
import { filtersActions, repairItemActions } from 'src/ducks/actions'
import { getRepairlistFilter } from 'src/ducks/filters/selector'
import { getPriceList } from 'src/ducks/selectors'
import useStyles from '../../../styles'

import { round } from 'src/helpers'
import stylesNew from './styles.module.scss'

const TerritoryPricing = () => {
  const dispatch = useDispatch()

  const styles = useStyles()

  const { id } = useParams()

  const priceList = useSelector(getPriceList)
  const repairListFilter = useSelector(getRepairlistFilter())

  const [loading, setLoading] = useState<boolean>(false)

  const handleSelectAllTerritories = (checked: boolean) => {
    const totalTerritories = priceList.length
    const selectedTerritoriesIndexes = Array.from({ length: totalTerritories }, (_, index) => index)
    if (checked) {
      dispatch(
        filtersActions.setFilters({
          repairList: { ...repairListFilter, selectedTerritoryIndexes: selectedTerritoriesIndexes },
        })
      )
    } else {
      dispatch(
        filtersActions.setFilters({
          repairList: { ...repairListFilter, selectedTerritoryIndexes: [] },
        })
      )
    }
  }

  const headers: HeaderType[] = [
    {
      id: 'check',
      label: <Checkbox onChange={(e) => {
        e.stopPropagation()
        handleSelectAllTerritories(e.target.checked)
      }} />,
      custom: true,
      align: 'center' as AlignType,
      Element: (row: any): JSX.Element => {
        return (
          <Box padding="2px 10px">
            <Checkbox checked={!!row.checked} onClick={() => row.onClick(row.index)} />
          </Box>
        )
      },
    },
    {
      id: 'territory',
      label: 'Territory',
      custom: true,
      align: 'left' as AlignType,
      Element: (row: any): JSX.Element => {
        return (
          <Box padding="2px 10px">
            <Typography className={stylesNew.Companies__companyName}>
              {row?.territory?.title || 'Default'}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'laborRate',
      label: 'Labor Rate',
      custom: true,
      align: 'left' as AlignType,
      Element: (row: any): JSX.Element => {
        return (
          <Box padding="2px 10px">
            <Typography className={stylesNew.Companies__companyName}>
              {`${row?.laborRate}`}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'cost',
      label: 'Cost',
      custom: true,
      align: 'center' as AlignType,
      Element: (row: any): JSX.Element => {
        return (
          <Box padding="2px 10px">
            <Typography className={stylesNew.Companies__companyName}>
              {`$${row?.unitCost}`}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'price',
      label: 'Price',
      custom: true,
      align: 'center' as AlignType,
      Element: (row: any): JSX.Element => {
        return (
          <Box padding="2px 10px">
            <Typography className={stylesNew.Companies__companyName}>
              {`$${row?.unitPrice}`}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'profit',
      label: 'Profit',
      custom: true,
      align: 'center' as AlignType,
      Element: (row: any): JSX.Element => {
        return (
          <Box padding="2px 10px">
            <Typography className={stylesNew.Companies__companyName}>
              {round(row?.profit, 2)}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'margin',
      label: 'Margin',
      custom: true,
      align: 'center' as AlignType,
      Element: (row: any): JSX.Element => {
        return (
          <Box padding="2px 10px">
            <Typography className={stylesNew.Companies__companyName} style={{ color: 'var(--blue700)' }}>
              {`${row?.margin}%`}
            </Typography>
          </Box>
        )
      },
    },
  ]

  const [selectedIndex, setSelectedIndex] = useState<number>(-1)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setLoading(true)

    dispatch(
      repairItemActions.fetchPriceList(id || '', (succ: boolean) => {
        setLoading(false)
      })
    )

    dispatch(
      filtersActions.setFilters({
        repairList: {
          ...repairListFilter,
          selectedTerritoryIndexes: [],
        },
      })
    )
  }, [])

  const handleTerritoryCheck = (index: number) => {
    const newIndexes = repairListFilter.selectedTerritoryIndexes?.includes(
      index
    )
      ? repairListFilter.selectedTerritoryIndexes?.filter(
        (idx) => idx !== index
      )
      : [...(repairListFilter.selectedTerritoryIndexes || []), index]

    dispatch(
      filtersActions.setFilters({
        repairList: {
          ...repairListFilter,
          selectedTerritoryIndexes: newIndexes,
        },
      })
    )

    if (newIndexes.length > 0) {
      setSelectedIndex(newIndexes.at(0) || -1)
      dispatch(
        repairItemActions.setPriceItem(priceList[newIndexes.at(0) || 0])
      )
    } else {
      setSelectedIndex(-1)
    }
  }

  return (
    <Box className={styles.tabContainer}>
      <Table
        headers={headers}
        hasPagination={false}
        loading={loading}
        selectedRow={selectedIndex}
      >
        {priceList.sort((a, b) => {
          const titleA = a.territory?.title || '';
          const titleB = b.territory?.title || '';
          return titleA.localeCompare(titleB);
        }).map((_item, index) =>
          repairListFilter.selectedTerritoryIndexes?.includes(index)
            ? { ..._item, checked: true, onClick: handleTerritoryCheck, index }
            : { ..._item, checked: false, onClick: handleTerritoryCheck, index }
        ) || []}
      </Table>
    </Box>
  )
}

export default TerritoryPricing
